import React from "react";
import { useState } from "react";

export const usePagination = ({limit, edgeNum=3}) => {
	const [total, setTotal] = useState(0);
	const [pageIndex, setPageIndex] = useState(0);

	const pageMax = Math.ceil(total / limit);
	const offset = (pageIndex-1) * limit;

	const beginPage = Math.max(2, Math.min(pageIndex - edgeNum, pageMax - (edgeNum * 2 + 1)));
	const endPage = Math.min(Math.max(pageIndex + edgeNum, 1 + (edgeNum * 2 + 1)), pageMax-1);

	const pages = [];
	if (pageMax > 0) {
		pages.push(1);
	}
	for (let i = beginPage; i <= endPage; ++i)
	{
		if (i == beginPage && i > 2) {
			pages.push(-1);
		}
		else if (i == endPage && i < pageMax - 1) {
			pages.push(-1);
		}
		else {
			pages.push(i);
		}
	}
	if (pageMax > 1) {
		pages.push(pageMax);
	}

	const onClickPage = (p) => {
		if (pageIndex != p && 1 <= p && p <= pageMax) {
			setPageIndex(p);
		}
	};

	return {
		limit,
		total,
		setTotal,
		pageIndex,
		setPageIndex,
		pageMax,
		pages,
		onClickPage,
		offset
	};
};
